import { BEHAVIOUR_DRAG_STRENGTH_IMPROVEMENT } from "../../../constants";

export const behaviourDragUpdateAction = () => {
    return (dispatch) => {
        dispatch({ type: BEHAVIOUR_DRAG_STRENGTH_IMPROVEMENT });
    }
}